function countPercent(partial, total) {
  const result = total > 0 ? (100 * partial) / total : 0;
  return Number.isInteger(result) ? Math.round(result) : Math.round(Number.parseFloat(result));
}

export default countPercent;
